import { DateTime } from 'luxon'
import { OfferStatus } from '../../modules/privateOffer/types'

export const isOfferExpired = (
  expirationDate: Date,
  status?: OfferStatus | string,
  now = DateTime.now
) => {
  const expiryDateAndTime = DateTime.fromISO(
    expirationDate.toISOString()
  ).endOf('day')
  const currentDateTime = now().endOf('day')

  if (status) {
    return (
      expiryDateAndTime < currentDateTime &&
      status !== OfferStatus.PRIVATE_OFFER_ACCEPTED
    )
  }
  return expiryDateAndTime < currentDateTime
}
